<template>
  <div class="c-light-65-fluffy">
    <div class="item">
      <label>灯效：</label>
      <md-field class="field">
        <md-select v-model="lightType" class="select">
          <md-option
            v-for="(text, index) in [
              '闪烁灯效',
              '静态灯效',
              '呼吸灯效',
              '循环渐变',
              '马赛克',
              '中心扩散',
              '横向滚动',
              '横向扩散',
              '竖向扩散',
              '按键亮熄',
            ]"
            :value="index"
            :key="'key' + index"
          >
            {{ text }}
          </md-option>
          <template v-if="had_json > 0">
            <md-option
              v-for="(text, index) in ['自定义1', '自定义2', '自定义3']"
              :value="index + 10"
              :key="'key' + index + 10"
            >
              {{ text }}
            </md-option>
          </template>
        </md-select>
      </md-field>
    </div>
    <div class="item" v-show="[0, 1, 2].includes(lightType)">
      <label>色相：</label>
      <c-slider
        class="color-slider"
        :value="color"
        :swatches="[]"
        @input="onColorInput"
      />
      <div class="color" :style="{ backgroundColor: color }"></div>
      <div class="num">
        {{ color }}
      </div>
    </div>
    <div class="item" v-show="[0, 1, 2].includes(lightType)">
      <label>饱和度：</label>
      <a-slider
        class="slider short"
        v-model="saturationPer"
        :min="0"
        :max="100"
        :tooltipVisible="false"
      />
      <div class="num">{{ saturationPer }} %</div>
    </div>
    <div class="item" v-show="[0, 1, 2].includes(lightType)">
      <label>明度：</label>
      <a-slider
        class="slider"
        v-model="brightnessPer"
        :min="0"
        :max="100"
        :tooltipVisible="false"
      />
      <div class="num">{{ brightnessPer }} %</div>
    </div>
    <div class="item">
      <label>速度：</label>
      <a-slider
        class="slider"
        v-model="speed"
        :min="0"
        :max="100"
        :tooltipVisible="false"
      />
      <div class="num">{{ speed }}</div>
    </div>
    <div class="item">
      <label>亮度：</label>
      <a-slider
        class="slider"
        v-model="brightness"
        :min="0"
        :max="255"
        :tooltipVisible="false"
      />
      <div class="num">{{ brightness }}</div>
    </div>
    <div class="item">
      <label>开关：</label>
      <md-switch class="md-primary" v-model="lightStatus"></md-switch>
    </div>
    <div class="button" @click="onSave">
      {{ $t("yes") }}
    </div>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="''"
      :image="images['device_dr002']"
      @close="percent = -1"
      style="position: absolute; height: auto; padding: 0;"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CLight65Fluffy",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      //灯效：呼吸灯，
      lightType: 0,
      //颜色：#ff1100
      color: "#ff1100",
      //饱和度百分比：0~100%，
      saturationPer: 1,
      //明暗百分比：0~100%,
      brightnessPer: 90,
      //速度：0~100，
      speed: 100,
      //亮度：0~255，
      brightness: 255,
      //模式：Windows/mac
      lightStatus: 1,
      had_json: 1,
      percent: -1,
      isInitializing: true, // 标记是否正在初始化
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      currentDevice: "currentDevice",
    }),
  },
  methods: {
    onColorInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.color = color.length === 7 ? color : "#000000";
    },
    onSave() {
      this.$store.dispatch("loader/sendKeyLight", {
        lightType: this.lightType,
        color: this.color,
        saturationPer: this.saturationPer,
        brightnessPer: this.brightnessPer,
        speed: this.speed,
        brightness: this.brightness,
        lightStatus: this.lightStatus ? 1 : 0,
        had_json: this.had_json,
      });
      // this.percent = 50;
      // setTimeout(() => {
      //   this.percent = -1;
      this.$message.info(this.$t("loader.saveSuccess"));
      // }, 2000);
    },
  },
  watch: {
    lightType() {
      this.$store.dispatch("loader/getKeyLight", {
        currentPort: this.currentDevice.port,
        lightType: this.lightType,
        init: 0,
      });
    },
    lightStatus() {
      // 初始化时不触发保存
      if (this.isInitializing) return;
      this.onSave();
    },
  },
  mounted() {
    this.$store.dispatch("loader/getKeyLight", {
      currentPort: this.currentDevice.port,
      lightType: this.lightType,
      init: 1,
    });
    window.upKeyLight = (json) => {
      if (json) {
        console.log("upKeyLight", json);
        const data = JSON.parse(json);
        this.lightType = data.lightType;
        this.color = data.color;
        this.saturationPer = data.saturationPer;
        this.brightnessPer = data.brightnessPer;
        this.speed = data.speed;
        this.brightness = data.brightness;
        this.lightStatus = data.lightStatus === 1;
        this.had_json = data.had_json;
        console.log("upKeyLight", "true");
        
        // 初始化完成后，允许 watch 触发保存
        this.$nextTick(() => {
          this.isInitializing = false;
        });
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.c-light-65-fluffy {
  padding-top: 20px;

  .item {
    @include flex-center;
    height: 45px;
    justify-content: flex-start;

    label {
      width: 120px;
      text-align: left;
    }

    .field {
      width: 320px;
    }

    .slider {
      width: 320px;
      margin-left: 0px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
      }
    }

    .color-slider {
      width: 320px;
      height: 10px;
      margin-right: 10px;
    }

    .color {
      width: 25px;
      height: 25px;
      border: 1px solid $primary-color;
      margin-left: 30px;

      & + .num {
        margin-left: 10px;
      }
    }

    .num {
      width: 80px;
      text-align: left;
      margin-left: 30px;
      white-space: nowrap;
    }
  }

  .button {
    @include button;
    width: 80px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;
    margin: 30px auto 0 auto;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>
<style lang="scss">
.c-light-65-fluffy {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .md-switch.md-theme-default.md-checked.md-primary .md-switch-container {
    background-color: rgb(0, 200, 0);
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
